import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { CarrierSingleField } from '@app/services/carriers/carrier.model';
import { CarriersFieldsTypes } from '@pdqdev/pdq-shared/dist/CarrierData';
import { JSONMappingFieldDialog } from './json-mapping-field.dialog/json-mapping-field.dialog';

const OPTION_LABEL_NAME = 'name';
const OPTION_VALUE_NAME = 'value';

const invalidChars = ['-', '+', 'e'];

@Component({
  selector: 'app-carrier-form-field',
  templateUrl: './carrier-form-field.component.html',
  styleUrls: ['./carrier-form-field.component.scss'],
  standalone: false,
})
export class CarrierFormFieldComponent implements OnInit, OnDestroy {
  @Input() fieldConfig: CarrierSingleField;
  @Input() formSubmitAttempt: boolean;
  @Input() control: UntypedFormControl;
  @Input() isMetaField: boolean = false;
  @Input() formGroup: UntypedFormGroup;
  @Input() isReadOnly: boolean = false;
  @Input() isHidden: boolean = false;
  @Input() carrierOperationMode: 'TEST' | 'LIVE' = 'LIVE';
  inputNumber: any = undefined;
  CarrierFieldConfigType = CarriersFieldsTypes;
  showSelectPlaceholder = true;
  readonly ERROR_REQUIRED_MESSAGE = 'This field is required';

  constructor(private dialog: MatDialog) {}

  get checkboxOptionsFormArray(): UntypedFormArray {
    return this.formGroup.get('check') as UntypedFormArray;
  }

  ngOnInit(): void {}

  preventDefaultKeys(): void {
    this.inputNumber = document?.getElementById('input-number');
    this.inputNumber?.addEventListener('keydown', function (e) {
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });
  }

  showRequiredError() {
    return this.control?.errors?.required && this.formSubmitAttempt;
  }

  showValidationError(): boolean {
    return !this.control?.errors?.required && this.control?.errors?.pattern && this.formSubmitAttempt;
  }

  getOptionLabelName() {
    return OPTION_LABEL_NAME;
  }

  getOptionValueName() {
    return OPTION_VALUE_NAME;
  }

  onChangeNgSelect() {
    this.showSelectPlaceholder = false;
  }

  onClearNgSelect() {
    this.showSelectPlaceholder = true;
  }

  ngOnDestroy() {
    if (this.inputNumber) {
      this.inputNumber?.removeEventListener('keydown', function (e) {
        if (invalidChars.includes(e.key)) {
          e.preventDefault();
        }
      });
    }
  }

  openMappingsWindow(event) {
    event.preventDefault();

    const title = `Edit ${this.fieldConfig?.displayName?.toLocaleLowerCase() || 'mappings'}`;
    const jsonMappingFieldDialog = this.dialog.open(JSONMappingFieldDialog, {
      data: {
        title,
        value: this.control.value,
        options: this.fieldConfig.options,
        additionalValueOptions: this.fieldConfig.additionalValueOptions,
        newKeyPlaceholder: this.fieldConfig.newKeyPlaceholder,
        defaultMappings: this.fieldConfig.defaultMappings,
        freeTextSupport: !!this.fieldConfig.generalSettings?.freeTextSupport,
      },
      autoFocus: false,
      panelClass: 'json-mapping-field-dialog',
    });

    jsonMappingFieldDialog.componentInstance.onSave.subscribe((value) => {
      this.control.setValue(value);
    });
  }
}
